import { ALERT, LOADING_BAR, STORE_BRAND, STORE_LANGUAGE, STORE_MOBILE_VERSION_ACTION } from '../constants/action-types'
import { LOCALE_ES } from '../../utils/constants'

const initialState = {
  showFail: false,
  showSuccess: false,
  code: '-1',
  errorMessage: undefined,
  loading: false,
  language: LOCALE_ES,
  mobileVersion: false,
  brand: {}
}

function reducer(state = initialState, action) {
  switch (action.type) {
    case ALERT:
      return {
        ...state,
        showFail: action.showFail,
        showSuccess: action.showSuccess,
        code: action.code?.toString(),
        errorMessage: action.errorMessage
      }
    case LOADING_BAR:
      return {
        ...state,
        loading: action.loading
      }
    case STORE_LANGUAGE:
      return {
        ...state,
        language: action.language
      }
    case STORE_MOBILE_VERSION_ACTION:
      return {
        ...state,
        mobileVersion: action.mobileVersion
      }
    case STORE_BRAND:
      return {
        ...state,
        brand: action.brand
      }
    default:
      return state
  }
}

export default reducer
